<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['data'],
  computed:{
    gridColor() {
      return (this.$vuetify.theme.dark) ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
    },
    options() {
      return {
        responsive: true,
        legend: {
          position: 'bottom',
          display: false
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Month'
            },
            gridLines: {
              color: this.gridColor,
              tickMarkLength: 4,
              zeroLineColor: 'rgba(0,0,0,0)'
            },
            ticks: {
              padding: 5
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Value'
            },
            gridLines: {
              color: this.gridColor,
              tickMarkLength: 4,
              zeroLineColor: 'rgba(0,0,0,0)'
            },
            ticks: {
              padding: 4
            }
          }]
        },
        title: {
          display: false,
          text: 'Wykres temperatur'
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>